import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {},
    description: {
      color: COLORS.neutral.mediumGray,
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(19),
      letterSpacing: 0,
      marginBottom: theme.spacing(1.25),
    },
    selectMenuRoot: {
      display: 'block',
      width: '100%',
      marginBottom: theme.spacing(2.5),

      '& > div': {
        width: '100%',
      },
    },
    selectItem: {
      fontSize: theme.typography.pxToRem(12),
    },
    buttonAction: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightMedium,
    },
    iconButtonPlus: {
      '&&': {
        fontSize: theme.typography.pxToRem(24),
      },
    },
    menuPaper: {
      overflowY: 'auto',
      maxHeight: 394,
    },
  }),
  {
    name: 'CustomModelPanel',
  }
);
